'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const twicpicsTransformationChainToString = (transformationChain) => {
    if (transformationChain.length === 0)
        return '';
    const transformations = transformationChain.map(([key, value]) => `${key}=${value}`).join('/');
    return `twic=v1/${transformations}`;
};

exports.twicpicsTransformationChainToString = twicpicsTransformationChainToString;
//# sourceMappingURL=twicpics-transformations.util.js.map
